export const environment = {
  production: true,
  deployAssetsPath: 'FrameworkVision',
  baseHref: '/FrameworkVision/',
  firebase: {
    apiKey: 'AIzaSyBYxxZev6X0BzKm0YS2cU2z5S06ENUR91A',
    authDomain: 'frameworkvision-89e98.firebaseapp.com',
    projectId: 'frameworkvision-89e98',
    storageBucket: 'frameworkvision-89e98.appspot.com',
    messagingSenderId: '856764102143',
    appId: '1:856764102143:web:f1d7dfaf3e33084a3de3ca',
    measurementId: 'G-R1Z2B2M0NF'
  },
  applicationName: 'FrameworkVision',
  firebaseDebug: false,
  logInBackgroundImage: 'assets/images/login.png',
  logInBoxLogo: 'assets/images/logo/log-in-logo.png',
  dashboardImage: 'assets/images/background/dashboard.png',
  topBarLogo: 'assets/images/logo/logo.png',
  userGuidePath: 'assets/user-guide/FrameworkVision User Guide.pdf',
  appConfigPath: 'assets/app-config.json',
  siteDefaults: {
    LogInBackgroundColor: '#ff9933',
    logInBackgroundImageSymbols: 'images/defaults/login-icons.png',
    logInBackgroundImageSymbolsNoText: 'images/defaults/login-icons-no-text.png',
    logInBackgroundImageVision: 'images/defaults/login-orange.png',
    logInBoxLogo: 'images/defaults/logo.png',
    dashboardImage: 'images/defaults/dashboard.png',
    topBarLogo: 'images/defaults/logo.png'
  },
  woltersKluwerEulaPath: '/assets/eula/wolters-kluwer-eula.pdf'
};
